import { ArrowUpRight } from "lucide-react";

export const ProjectCard = ({ p, testid }) => (
  <figure
    data-testid={testid}
    className="group relative h-full w-full overflow-hidden rounded-sm bg-beige"
  >
    <img
      src={p.img}
      alt={`${p.title} — ${p.location}`}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-espresso/70 via-espresso/5 to-transparent" />
    <figcaption className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-5 sm:p-6">
      <div>
        <p className="font-display text-xl font-light text-offwhite sm:text-2xl">{p.title}</p>
        <p className="mt-1 font-grotesk text-[11px] uppercase tracking-[0.22em] text-offwhite/75">
          {p.location}
        </p>
      </div>
      <span className="hidden h-9 w-9 shrink-0 place-items-center rounded-full border border-offwhite/40 text-offwhite opacity-0 transition-all duration-300 group-hover:opacity-100 sm:grid">
        <ArrowUpRight className="h-4 w-4" />
      </span>
    </figcaption>
  </figure>
);
